import { apiDaInscricao } from "../../../servicos/axios";

export type CidadePorUf = {
  id: number;
  nome: string;
  cepPadrao?: string;
  estado: {
    id: number;
    uf: string;
  };
};

export const buscarCidadesPorUf = async (
  uf: string
): Promise<CidadePorUf[]> => {
  const response = await apiDaInscricao().get(`/Cidades/BuscarPorUf/${uf}`);
  return response.data;
};
